import React from 'react';
import { startContent } from '../../../../constants/copyright';
import { safeHTML } from '../../../../utils/safeHTML';
import StartBodyButtons from './StartBodyButtons';
import { useTranslation } from '../../../../translations';

const { title } = startContent;

const StartBody = React.forwardRef(function (_, ref) {
  const { t } = useTranslation();

  return (
    <div className={'start__body'}>
      <h1 className={'start__title'}>{safeHTML(t(title))}</h1>
      <StartBodyButtons />
    </div>
  );
});
export default StartBody;
